import { Injectable } from '@angular/core'
import { CommonService } from '../../shared/services/common.service'

@Injectable({
  providedIn: 'root',
})
export class MyFavouritesService {
  constructor(public commonService: CommonService) {}

  removeProducts(productsList) {
    const urlParams = ['users', 'current', 'deleteProductsFromFavourites']
    const apiUrl = this.commonService.constructUrl(urlParams)
    return this.commonService.postData(apiUrl, productsList)
  }

  fetchFavoritesList(defaultPage, itemsPerPage, searchId?) {
    const urlParam = ['users', 'current', 'getFavouritesList']
    const url = this.commonService.constructUrl(urlParam)
    const apiParams = {
      currentPage: defaultPage,
      pageSize: itemsPerPage,
      fields: 'DEFAULT',
      searchCode: searchId,
    }
    return this.commonService.getData(url, apiParams)
  }

  postProductsToBUYCart(productsList, cartID) {
    const urlParam = ['users', 'current', 'carts', cartID, 'bomEntries']
    const url = this.commonService.constructUrl(urlParam)
    let orderEntriesArray = []
    let orderEntryObj = {}
    for (let i = 0; i < productsList.length; i++) {
      orderEntryObj = {
        product: {
          code: productsList[i].product.code,
        },
        quantity: productsList[i].quantity,
      }
      orderEntriesArray.push(orderEntryObj)
    }
    const apiParams = {
      orderEntries: orderEntriesArray,
    }
    return this.commonService.postData(url, apiParams)
  }

  postProductsToQUOTECart(productsList, rfqCartId) {
    const urlParam = ['users', 'current', 'rfqcart', rfqCartId, 'bomRfqEntries']
    const url = this.commonService.constructUrl(urlParam)
    let quoteEntriesArray = []
    let quoteEntryObj = {}
    for (let productItem of productsList) {
      quoteEntryObj = {
        brandCode: productItem.product.productLine,
        brandName: productItem.product.productLine,
        comment: '',
        customerRequestedDate: new Date(Date.now())
          .toISOString()
          .slice(0, 19)
          .replace(/-/g, '/')
          .split('T')[0],
        productType: 'Part',
        quantity: productItem.quantity || 1,
        reasonForQuote: '',
        rfqPartDescription: productItem.product.name,
        rfqPartNumber: productItem.product.code,
        //  serialNumber: productItem.product.code,
        //  tagNumber: productItem.product.code,
      }
      quoteEntriesArray.push(quoteEntryObj)
    }
    const apiParams = {
      quoteEntryList: quoteEntriesArray,
    }
    return this.commonService.postData(url, apiParams)
  }
}
